import { useEffect, useState, useRef } from "react";
import {
  Container,
  FormControl,
  FormGroup,
  Button as BsButton,
  Modal,
  Card,
  Form,
  Row,
  Col,
  CardGroup,
  ListGroup,
} from "react-bootstrap";
import { useParams } from "react-router-dom";
import DemographicInfo from "../shared/users/DemographicInfo";
import staffService from "../services/staff.service";
import { toast } from "react-toastify";
import Loading from "../shared/Loading";
import { TooltipLink } from "../Helper";
import { Typeahead } from "react-bootstrap-typeahead";
import CommonTree from "../shared/CommonTree";
import MobileOtp from "../onboarding/MobileOtp";
import EmailOtp from "../onboarding/EmailOtp";
import bpService from "../services/bp.service";
import moment from "moment";
const StaffDetail = () => {
  const { kapid_id } = useParams();
  const [staff, setStaff] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [newStaffModal, setNewStaffModal] = useState(false);
  const [newStaffFormValidated, setNewStaffFormValidated] = useState(false);
  const [validDesignation, setValidDesignation] = useState(true);
  const [typeaheadSelections, setTypeaheadSelections] = useState({
    staffType: [],
    branch: [],
  });
  const [masterData, setMasterData] = useState({
    roles: [],
    emp_types: [],
    branches: [],
  });
  const [additionalData, setAdditionalData] = useState({
    posds: [],
    spls: [],
  });
  const newStaffRef = useRef([]);

  useEffect(() => {
    async function fetchInitialData() {
      try {
        const staffData = await staffService.getStaffUser(kapid_id);
        console.log(staffData);
        if (!staffData.emp_data) {
          const roles = await staffService.getRolesDesignations();
          const emp_types = await staffService.getStaffTypes();
          const branches = await bpService.getBranches();
          setMasterData((m) => ({ ...m, roles, emp_types, branches }));
        }
        setStaff(staffData);

        setIsLoading(false);
      } catch (error) {
        setIsLoading("error");
        toast.error("Something went wrong! Try Again!");
      }
    }
    fetchInitialData();
  }, [kapid_id]);
  useEffect(() => {
    async function fetchAditionalData(data) {
      try {
        console.log("Calling additional data load");
        const posds = await staffService.getEmpPosds(data.bp_emp_base_id);
        const spls = await staffService.getEmpSpls(data.bp_emp_base_id);
        setAdditionalData((a) => ({ ...a, posds, spls }));
        console.log(posds, spls);
      } catch (error) {
        // setIsLoading("error");
        toast.error("Something went wrong! Try Again!");
      }
    }
    if (staff && staff.emp_data) fetchAditionalData(staff.emp_data);
  }, [staff]);
  const handleRoleChange = (selectedPayerNode) => {
    if (selectedPayerNode.length > 0) {
      var payerNode = selectedPayerNode[0];
      if (payerNode.data.type === "designation") {
        setValidDesignation(true);
      } else {
        setValidDesignation(false);
      }
    }
  };
  const handleStartDateChange = (e) => {
    const start_date = new Date(e.target.value);
    newStaffRef.current.end_date.setAttribute(
      "min",
      start_date.toISOString().split("T")[0]
    );
  };
  const handleNewStaffForm = async (e) => {
    e.preventDefault();
    let error = false;
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      error = true;
    }
    const tree = newStaffRef.current.role;
    if (tree.hasNoSelection || !validDesignation) {
      error = true;
      toast.error("Please select a designation!");
    }
    if (
      !typeaheadSelections.branch ||
      typeaheadSelections.branch.length === 0
    ) {
      error = true;
      toast.error("Please select a branch!");
    }
    if (
      !typeaheadSelections.staffType ||
      typeaheadSelections.staffType.length === 0
    ) {
      error = true;
      toast.error("Please select Employee Type!");
    }
    setNewStaffFormValidated(true);
    if (error) return false;

    var designation = newStaffRef.current.role.selectedNodes[0].data;
    const mobile = newStaffRef.current["mobile"].value;
    const email = newStaffRef.current["email"].value;
    const newStaff = {
      kapid_user_id: kapid_id,
      bp_br_id: typeaheadSelections.branch[0].bp_branch_id,
      emp_start_date: newStaffRef.current.start_date.value,
      emp_end_date:
        newStaffRef.current.end_date.value === ""
          ? null
          : newStaffRef.current.end_date.value,
      bp_emp_org_code: newStaffRef.current.bp_emp_org_code.value,
      bp_emp_type: typeaheadSelections.staffType[0].bp_emp_type_id,
      bp_emp_official_contact_list: [
        {
          contact_type: "mobile",
          contact_value: mobile.mobile,
          country: "",
          status: 1,
          verified: mobile.mobileVerified ? 1 : 0,
          mark_primary: 1,
        },
        {
          contact_type: "email",
          contact_value: email.email,
          country: "",
          status: 1,
          verified: mobile.emailVerified ? 1 : 0,
          mark_primary: 0,
        },
      ],
      bp_designation_id: designation.bp_designation_id,
      bp_role_id: designation.bp_role_id,
    };
    try {
      const data = await staffService.newStaff(newStaff);
      if (data) {
        setNewStaffFormValidated(false);
        setStaff({ ...staff, emp_data: data });
        toast.success("Staff Added Successfully!");
        setNewStaffModal(false);
      }
    } catch (error) {
      toast.error("Something went wrong! Try Again!");
    }
  };
  return (
    <Container>
      {isLoading && <Loading />}
      {isLoading === "error" && <Loading failed={true} />}
      {!isLoading && (
        <>
          <ul className="sticky-ul-container d-print-none">
            {!staff.emp_data && (
              <TooltipLink title={"New Staff"} id={"newStaff-tooltip"}>
                <BsButton
                  className="sticky-li bg-success"
                  onClick={() => {
                    setNewStaffModal(true);
                  }}
                  as="li"
                  variant="success"
                >
                  NS
                </BsButton>
              </TooltipLink>
            )}

            {staff.emp_data && (
              <TooltipLink title={"Test Button"} id={"testButton-tooltip"}>
                <BsButton
                  className="sticky-li bg-success"
                  // onClick={() => {
                  //   setIpdAdmissionModal(true);
                  // }}
                  as="li"
                  variant="success"
                >
                  TB
                </BsButton>
              </TooltipLink>
            )}
          </ul>
          <DemographicInfo
            user={staff}
            user_type={"staff"}
            border={staff.emp_data ? null : "danger"}
          />
          {staff.emp_data && (
            <>
              <Row className="g-3" xs={1} sm={1} md={3}>
                <Col>
                  <Card>
                    <Card.Header>Point of Service</Card.Header>
                    <ListGroup variant="flush">
                      {additionalData.posds.map((posd) => (
                        <ListGroup.Item key={posd.bp_emp_posd_id}>
                          {posd.point_of_service_delivery_name}
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  </Card>
                </Col>
                <Col>
                  <Card>
                    <Card.Header>Specialization</Card.Header>
                    <ListGroup variant="flush">
                      {additionalData.spls.map((spl) => (
                        <ListGroup.Item key={spl.bp_emp_spl_id}>
                          {spl.business_spl_name}
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  </Card>
                </Col>
                <Col>
                  <Card>
                    <Card.Header>Teams</Card.Header>
                    <ListGroup variant="flush"></ListGroup>
                  </Card>
                </Col>
              </Row>
            </>
          )}
          {!staff.emp_data && (
            <>
              <Modal
                show={newStaffModal}
                onHide={() => setNewStaffModal(false)}
                backdrop="static"
                keyboard={false}
                fullscreen
              >
                <Modal.Header closeButton className="p-2">
                  <Modal.Title>
                    New Staff - {staff.first_name} {staff.last_name} (
                    {staff.user_kapid_id?.toUpperCase()})
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Container>
                    <Form
                      onSubmit={handleNewStaffForm}
                      validated={newStaffFormValidated}
                      noValidate
                      id="new-staff-form"
                    >
                      {/* <DemographicInfo patient={patient} /> */}
                      <Card className="bg-new mb-3">
                        <Card.Header as="h5">Mandatory information</Card.Header>
                        <Card.Body>
                          <Row>
                            <Col xs={12} sm={12} md={6}>
                              <Card
                                body
                                border={
                                  validDesignation ? "secondary" : "danger"
                                }
                              >
                                <h3>Role and Designation</h3>
                                <CommonTree
                                  data={masterData.roles}
                                  ref={(el) =>
                                    (newStaffRef.current["role"] = el)
                                  }
                                  childrenAccessor="designations"
                                  onSelect={(nodes) => handleRoleChange(nodes)}
                                />
                              </Card>
                            </Col>
                            <Col>
                              <FormGroup
                                className="mb-3"
                                controlId="staff-type"
                              >
                                <Form.Label>Staff Type</Form.Label>
                                <Typeahead
                                  options={masterData.emp_types}
                                  placeholder="Select type"
                                  id="staff-type"
                                  labelKey={"emp_type_name"}
                                  multiple={false}
                                  inputProps={{ required: true }}
                                  filterBy={() => true}
                                  selected={typeaheadSelections.staffType}
                                  onChange={(s) =>
                                    setTypeaheadSelections({
                                      ...typeaheadSelections,
                                      staffType: s,
                                    })
                                  }
                                ></Typeahead>
                              </FormGroup>
                              <FormGroup className="mb-3" controlId="org-code">
                                <Form.Label>Org. Code</Form.Label>
                                <FormControl
                                  ref={(el) =>
                                    (newStaffRef.current["bp_emp_org_code"] =
                                      el)
                                  }
                                ></FormControl>
                              </FormGroup>
                              <FormGroup className="mb-3" controlId="branch">
                                <Form.Label>Branch</Form.Label>
                                <Typeahead
                                  options={masterData.branches}
                                  placeholder="Select Branch"
                                  id="branch"
                                  labelKey={"bp_branch_name"}
                                  multiple={false}
                                  inputProps={{ required: true }}
                                  filterBy={() => true}
                                  selected={typeaheadSelections.branch}
                                  onChange={(s) =>
                                    setTypeaheadSelections({
                                      ...typeaheadSelections,
                                      branch: s,
                                    })
                                  }
                                ></Typeahead>
                              </FormGroup>
                              <FormGroup
                                className="mb-3"
                                controlId="start-date"
                              >
                                <Form.Label>Start Date</Form.Label>
                                <FormControl
                                  type="date"
                                  ref={(el) =>
                                    (newStaffRef.current["start_date"] = el)
                                  }
                                  required={true}
                                  min={moment().format("YYYY-MM-DD")}
                                  defaultValue={moment().format("YYYY-MM-DD")}
                                  onChange={(e) => handleStartDateChange(e)}
                                ></FormControl>
                              </FormGroup>
                              <FormGroup className="mb-3" controlId="end-date">
                                <Form.Label>End Date</Form.Label>
                                <FormControl
                                  type="date"
                                  ref={(el) =>
                                    (newStaffRef.current["end_date"] = el)
                                  }
                                  // required={true}
                                  min={moment().format("YYYY-MM-DD")}
                                  // defaultValue={moment().format("YYYY-MM-DD")}
                                ></FormControl>
                              </FormGroup>
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                      <Card className="bg-new mb-3">
                        <Card.Header as="h5">
                          Official Contact Detail
                        </Card.Header>
                        <Card.Body>
                          <Row xs={1} sm={1}>
                            <Col>
                              <MobileOtp
                                required={true}
                                ref={(el) =>
                                  (newStaffRef.current["mobile"] = el)
                                }
                              />
                            </Col>
                            <Col>
                              <EmailOtp
                                required={true}
                                ref={(el) =>
                                  (newStaffRef.current["email"] = el)
                                }
                              />
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    </Form>
                  </Container>
                </Modal.Body>
                <Modal.Footer className="py-0">
                  <BsButton
                    type="button"
                    variant="secondary"
                    onClick={() => setNewStaffModal(false)}
                  >
                    Cancel
                  </BsButton>
                  <BsButton
                    type="submit"
                    variant="primary"
                    form="new-staff-form"
                  >
                    Save
                  </BsButton>
                </Modal.Footer>
              </Modal>
            </>
          )}
        </>
      )}
    </Container>
  );
};

export default StaffDetail;
